import {until} from 'lit-html/directives/until';
import '@modules/dropdown';
import {dashboardLabels, generalLabels, gradesLabels} from '@modules/i18n-labels';
import {generalAriaLabels} from '@modules/i18n-labels';
import '@modules/aofl-form';

/**
 * I had to include this because the styles are getting stripped out on build otherwise
 */
const cssClasses = ['bg-prior_knowledge', 'bg-credited', 'bg-in_progress', 'bg-mastery_achieved', 'bg-intervention'];

const getStatusFilter = (ctx, html) => html`
  <ems-dropdown class="mb-3 text-left ${ctx['for-student-view'] ? 'student-status-filter' : ''}">
    <button type="button" slot="dropdown-toggle" class="btn font-size-small d-flex justify-content-between w-100">
      <span class="mr-4">${until(ctx.selectedStatus)}</span>
      <span class="ai ai-chevron-down"></span>
    </button>
    <div slot="dropdown-menu" class="dropdown-menu">
      <button type="button"
        class="btn dropdown-item"
        @click="${() => ctx.setStatusFilter(null)}}"
        data-bi-id="status_filter_all_${ctx.product}">
        <span class="key-icon key-icon--all mr-3"></span> ${until(generalLabels.all)}
      </button>
      ${Object.values(ctx.nodeStatuses).map((item) => html`
          <button type="button"
            class="btn dropdown-item"
            @click="${() => ctx.setStatusFilter(item)}"
            data-bi-id="status_filter_${item}_${ctx.product}">
            <span class="mr-3 key-icon bg-${item}"></span> ${until(ctx.nodeStatusInfo[item])}
          </button>
        `)}
    </div>
  </ems-dropdown>`;

const getSearchInput = (ctx, html) => html`
  <div class="form-group text-left mb-3 search-form-group ${ctx['for-student-view'] ? 'student-view-search-form-group' : 'd-inline-flex'}">
    <input
      type="text"
      name="name"
      autocomplete="off"
      class="form-control form-control-sm"
      placeholder="${(ctx.standardSets?.length > 0) ? until(ctx.i18n.__('<tt-wBpf6/HK>', 'Search for a Skill or Standard Code')) : until(ctx.i18n.__('<tt-wJH2hXw9>', 'Search for a Skill'))}"
      @input="${ctx.nameFilterInputDebounce}"
      title="Search for a Skill"
      value="${ctx.filters.nameFilter}">
    <div class="search-btns">
      <button type="submit" class="btn" aria-label="${until(generalAriaLabels.SEARCH)}"><span class="ai ai-search"></span></button>
    </div>
  </div>
`;
const getGradeFilter = (ctx, html) => {
  if (ctx['for-student-view']) {
    return;
  }

  if (ctx.filters.standardSetFilter || (ctx.standardSets.length === 0 && ctx.grades.length)) {
    return html`
    <ems-dropdown class="mb-3 text-left ${ctx['for-student-view'] ? 'student-grade-filter' : ''}">
      <button type="button" slot="dropdown-toggle" class="btn font-size-small d-flex justify-content-between w-100">
        <span class="mr-4">${until(ctx.filters.gradeFilter || dashboardLabels.SELECT_A_GRADE)}</span>
        <span class="ai ai-chevron-down"></span>
      </button>
      <div slot="dropdown-menu" class="dropdown-menu">
        <button type="button"
          class="btn dropdown-item"
          @click="${() => ctx.setGradeFilter(null)}}"
          data-bi-id="grade_filter_all_${ctx.product}">
            ${until(gradesLabels.ALL_GRADES)}
        </button>
        ${ctx.grades.map((grade) => html`
          <button type="button"
            class="btn dropdown-item"
            @click="${() => ctx.setGradeFilter(grade)}"
            data-bi-id="grade_filter_${grade}_${ctx.product}">
            ${until(gradesLabels.dynamicGrade(grade))}
          </button>
        `)}
      </div>
    </ems-dropdown>`;
  }
};

const getStandardSetFilter = (ctx, html) => {
  if (!ctx['for-student-view'] && ctx.standardSets.length > 0) {
    return html `
    <ems-dropdown class="mb-3 text-left">
      <button type="button" slot="dropdown-toggle" class="btn font-size-small d-flex justify-content-between">
        <span class="mr-4 ellipsis">${until(ctx.selectedStandardSet.label || dashboardLabels.SELECT_A_STANDARD_SET)}</span>
        <span class="ai ai-chevron-down"></span>
      </button>
      <div slot="dropdown-menu" class="dropdown-menu">
        <button
          type="button"
          class="btn dropdown-item"
          @click="${() => ctx.setStandardSetFilter(null)}}"
          data-bi-id="standard_set_filter_all_${ctx.product}">
          ${until(ctx.__('<tt-ngHRzrdz>', 'All Standard Sets'))}
        </button>
        ${ctx.standardSets.map((standardSet) => html`
          <button
            type="button"
            class="btn dropdown-item"
            @click="${() => ctx.setStandardSetFilter(standardSet.value)}"
            data-bi-id="standard_set_filter_${standardSet.label}_${ctx.product}">
            ${until(standardSet.label)}
          </button>
        `)}
      </div>
    </ems-dropdown>`;
  }
};
const getStandardCategoryFilter = (ctx, html) => {
  if ((ctx.filters.gradeFilter || ctx['for-student-view']) && ctx.standardSets.length > 0) {
    return html`
    <ems-dropdown class="mb-3 text-left standard-category-group ${ctx['for-student-view'] ? 'standard-category-group-student-view' : 'standard-category-group '}">
      <button type="button" slot="dropdown-toggle" class="btn font-size-small d-flex justify-content-between w-100">
        <span class="mr-4 ellipsis">${until(ctx.selectedStandardCategory)}</span>
        <span class="ai ai-chevron-down"></span>
      </button>
      <div slot="dropdown-menu" class="strand-dropdown dropdown-menu">
        <button
          type="button"
          class="btn dropdown-item"
          @click="${() => ctx.setStandardCategoryFilter(null)}}"
          data-bi-id="standard_category_filter_all_${ctx.product}">
        ${until(generalLabels.all)}
        </button>
        ${ctx.loParents.map((standardCategory) => html`
          <button type="button"
            class="btn dropdown-item"
            @click="${() => ctx.setStandardCategoryFilter(standardCategory)}"
            data-bi-id="standard_category_filter_${standardCategory}_${ctx.product}">
            ${until(standardCategory)}
          </button>
        `)}
      </div>
    </ems-dropdown>`;
  }
};

const getResetButton = (ctx, html) => html`
  <button class="${ctx['for-student-view'] ? 'w-100 text-center' : 'text-left'} btn btn-link font-size-small reset-button"
    @click="${ctx.resetFilters}"
    data-bi-id="reset_filters_${ctx.product}">
    ${until(ctx.__('<tt-mRgIYxWZ>', 'Reset All Filters'))}
  </button>
`;

export default (ctx, html) => html`
<aofl-form class="w-100"
  <form @submit="${ctx.setNameFilter}">
    ${ctx['for-student-view'] ?
      html`
        ${getStandardSetFilter(ctx, html)}
        <div class="d-flex flex-column flex-lg-row justify-content-md-center item-gap">
          ${getSearchInput(ctx, html)}
          ${getStatusFilter(ctx, html)}
          ${getGradeFilter(ctx, html)}
          ${getStandardCategoryFilter(ctx, html)}
        </div>
        ${getResetButton(ctx, html)}
    ` :
      html`
        <div class="text-center">
          <div class="mb-3">
             ${getSearchInput(ctx, html)}
             ${getStandardSetFilter(ctx, html)}
             ${getGradeFilter(ctx, html)}
             ${getStandardCategoryFilter(ctx, html)}
             <div class="d-inline-block flex-row">
               ${getStatusFilter(ctx, html)}
               ${getResetButton(ctx, html)}
             </div>
            </div>
          <node-status-legend class="d-inline-flex justify-content-center"></node-status-legend>
        </div>
    `}
  </form>
</aofl-form>
`;
